"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Exception = void 0;
var Exception = /** @class */ (function () {
    /**
     *
     */
    function Exception(message) {
        this.m_message = message;
    }
    Exception.prototype.getClass = function () {
        return { getSimpleName: function () { return "Exception"; } };
    };
    Exception.prototype.getMessage = function () {
        return this.m_message;
    };
    return Exception;
}());
exports.Exception = Exception;

//# sourceMappingURL=Exception.js.map
